/**
 * 익명 인증 결정 로직 — Firebase SDK/Phaser 무의존 순수 함수.
 *
 * initFirebase가 부팅마다 무조건 signInAnonymously를 호출하면, persistence가 비는 환경
 * (시크릿 모드 / Capacitor APK 재설치 / 여러 기기)에서 매번 새 익명 UID가 생겨 Firebase 콘솔에
 * 익명 계정이 폭증한다. authStateReady() 후 기존 익명 유저가 있으면 재사용해 신규 생성을 막는다.
 *
 * @param currentUser auth.authStateReady() 이후의 auth.currentUser (확정되기 전엔 항상 null).
 * @returns "reuse" — 기존 익명 유저 재사용 / "signInAnonymously" — 신규 익명 로그인 필요.
 */
export function resolveAuthAction(
  currentUser: { isAnonymous: boolean } | null,
): "reuse" | "signInAnonymously" {
  return currentUser?.isAnonymous ? "reuse" : "signInAnonymously";
}
